import React, { Component } from 'react';
import PropTypes from 'prop-types';
class Collapse extends Component {
    constructor(props) {
        super(props);

        this.state = { childHeight: 0 };
    }
    componentDidMount() {
        const childHeightRaw = this.content.clientHeight;
        const childHeight = this.props.isMobile
            ? `${childHeightRaw}rem`
            : `${childHeightRaw / 16}rem`;

        this.setState({ childHeight });
    }

    render() {
        const { children, isOpen, className, useHeightCalcs } = this.props;
        const { childHeight } = this.state;

        const heightCalcs = useHeightCalcs ? {
            maxHeight: isOpen ? childHeight : 0,
        } : {};

        return (
          <div
              className={`${className} animate_collapse_${isOpen ? 'open' : 'close'}`}
              style={heightCalcs}
              ref={(content) => (this.content = content)}
          >
            {children}
          </div>
        );
    }
}

Collapse.defaultProps = {
    isOpen: false,
    useHeightCalcs: true,
    className: '',
};

Collapse.propTypes = {
    children: PropTypes.shape,
    isOpen: PropTypes.bool,
    className: PropTypes.string,
    useHeightCalcs: PropTypes.bool,
    isMobile: PropTypes.bool
};
export default Collapse;



// WEBPACK FOOTER //
// ./src/client/components/Collapse/index.js